
export const Barriers = `EmploymentEquity/Barriers`;
export const SearchBarriers = Barriers + '/Search';
export const BarrierCategories = Barriers + '/BarrierCategories';
